import moment from "moment";
import "../css/batchSuggestionList.css";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { FcExpired } from "react-icons/fc";

const BatchSuggestionList = ({
  batch,
  handleSelectBatch,
  idx,
  getCheckedBatches,
  subIdx,
}) => {
  const pendingDays = moment(batch?.expiry_date).diff(moment(), "days");

  return (
    <div className="cu-invoice-batch-list-item">
      <div className="flex items-center gap-1">
        <input
          type="checkbox"
          className="cursor-pointer"
          checked={getCheckedBatches(batch?.batch_id)}
          onChange={(e) => handleSelectBatch(e, batch, idx, subIdx)}
        />
        {batch?.batch_number}
      </div>
      <div className="flex items-center">
        <span>
          <MdOutlineProductionQuantityLimits />
        </span>
        <span>{batch?.avl_batch_qty}</span>
      </div>
      <div className="flex items-center">
        <span>
          <FcExpired />
        </span>
        <span>{pendingDays}</span>
      </div>
    </div>
  );
};

export default BatchSuggestionList;
